import { createAction } from '@ngrx/store';

export const moveToCollectionSuccess = createAction('[Collections] Move To Collection Success');
export const moveToCollectionFailed = createAction('[Collections] Move To Collection Failed');
